export var DeviceConnectionStatus;
(function (DeviceConnectionStatus) {
    DeviceConnectionStatus["CONNECTED"] = "CONNECTED";
    DeviceConnectionStatus["DISCONNECTED"] = "DISCONNECTED";
    DeviceConnectionStatus["UNAUTHORIZED"] = "UNAUTHORIZED";
    DeviceConnectionStatus["OFFLINE"] = "OFFLINE";
    DeviceConnectionStatus["UNKNOWN"] = "UNKNOWN";
})(DeviceConnectionStatus || (DeviceConnectionStatus = {}));
export var DeviceHealthStatus;
(function (DeviceHealthStatus) {
    DeviceHealthStatus["HEALTHY"] = "healthy";
    DeviceHealthStatus["WARNING"] = "warning";
    DeviceHealthStatus["AT_RISK"] = "at_risk";
    DeviceHealthStatus["BANNED"] = "banned";
})(DeviceHealthStatus || (DeviceHealthStatus = {}));
export var DeviceRiskLevel;
(function (DeviceRiskLevel) {
    DeviceRiskLevel["LOW"] = "low";
    DeviceRiskLevel["MEDIUM"] = "medium";
    DeviceRiskLevel["HIGH"] = "high";
    DeviceRiskLevel["CRITICAL"] = "critical";
})(DeviceRiskLevel || (DeviceRiskLevel = {}));
export var TaskType;
(function (TaskType) {
    TaskType["POST_REEL"] = "POST_REEL";
    TaskType["POST_STORY"] = "POST_STORY";
    /** A YouTube Short: square or vertical, up to three minutes. */
    TaskType["POST_SHORT"] = "POST_SHORT";
    TaskType["POST_PHOTO"] = "POST_PHOTO";
    /** A regular (long-form) YouTube video. */
    TaskType["POST_VIDEO"] = "POST_VIDEO";
    TaskType["ACCOUNT_UPDATE"] = "ACCOUNT_UPDATE";
    TaskType["AI_SCROLL"] = "AI_SCROLL";
})(TaskType || (TaskType = {}));
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["QUEUED"] = "QUEUED";
    TaskStatus["RUNNING"] = "RUNNING";
    TaskStatus["COMPLETED"] = "COMPLETED";
    TaskStatus["FAILED"] = "FAILED";
    TaskStatus["CANCELLED"] = "CANCELLED";
})(TaskStatus || (TaskStatus = {}));
export var Platform;
(function (Platform) {
    Platform["INSTAGRAM"] = "instagram";
    Platform["TIKTOK"] = "tiktok";
    Platform["YOUTUBE"] = "youtube";
    Platform["TWITTER"] = "twitter";
    Platform["FACEBOOK"] = "facebook";
    /** No Android app (web only): PLATFORM_APP_TARGETS maps it to null. */
    Platform["ONLYFANS"] = "onlyfans";
})(Platform || (Platform = {}));
export var AccountStatus;
(function (AccountStatus) {
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["SUSPENDED"] = "SUSPENDED";
    AccountStatus["BANNED"] = "BANNED";
    AccountStatus["REQUIRES_LOGIN"] = "REQUIRES_LOGIN";
})(AccountStatus || (AccountStatus = {}));
export var TransportType;
(function (TransportType) {
    TransportType["DIRECT_LAN"] = "direct_lan";
    TransportType["AGENT_RELAY"] = "agent_relay";
})(TransportType || (TransportType = {}));
export var WebSocketEvent;
(function (WebSocketEvent) {
    WebSocketEvent["DEVICE_CONNECTED"] = "device:connected";
    WebSocketEvent["DEVICE_DISCONNECTED"] = "device:disconnected";
    WebSocketEvent["DEVICE_REMOVED"] = "device:removed";
    WebSocketEvent["STREAM_FRAME"] = "stream:frame";
    // H.264 video streaming (scrcpy provider). Client→server controls request a
    // device stream; server→client events carry codec metadata and encoded
    // chunks as base64 in the payload.
    WebSocketEvent["STREAM_START"] = "stream:start";
    WebSocketEvent["STREAM_STOP"] = "stream:stop";
    WebSocketEvent["STREAM_VIDEO_CODEC"] = "stream:video-codec";
    WebSocketEvent["STREAM_VIDEO_CHUNK"] = "stream:video-chunk";
    WebSocketEvent["STREAM_VIDEO_ERROR"] = "stream:video-error";
    WebSocketEvent["STREAM_VIDEO_END"] = "stream:video-end";
    WebSocketEvent["STREAM_VIDEO_STATS"] = "stream:video-stats";
    // Client -> server: request a keyframe to resync after dropped frames.
    WebSocketEvent["STREAM_KEYFRAME"] = "stream:keyframe";
    // Client -> server: newest video frame (pts) the viewer has received. Lets
    // the server measure each viewer's queueing delay and skip stale frames.
    WebSocketEvent["STREAM_VIDEO_ACK"] = "stream:video-ack";
    // Server -> client: live input availability for a device's stream.
    WebSocketEvent["STREAM_CONTROL"] = "stream:control";
    WebSocketEvent["TASK_PROGRESS"] = "task:progress";
    WebSocketEvent["TASK_COMPLETED"] = "task:completed";
    WebSocketEvent["TASK_FAILED"] = "task:failed";
    WebSocketEvent["CONTROL_TAP"] = "control:tap";
    WebSocketEvent["CONTROL_SWIPE"] = "control:swipe";
    WebSocketEvent["CONTROL_TYPE"] = "control:type";
    WebSocketEvent["CONTROL_SCREENSHOT"] = "control:screenshot";
    WebSocketEvent["CONTROL_BACK"] = "control:back";
    WebSocketEvent["CONTROL_HOME"] = "control:home";
    WebSocketEvent["CONTROL_RECENTS"] = "control:recents";
    WebSocketEvent["CONTROL_KEY"] = "control:key";
    // Live touch gesture step (down / move / up / cancel).
    WebSocketEvent["CONTROL_TOUCH"] = "control:touch";
    WebSocketEvent["CONTROL_RESPONSE"] = "control:response";
    WebSocketEvent["CONTROL_ERROR"] = "control:error";
})(WebSocketEvent || (WebSocketEvent = {}));
//# sourceMappingURL=device-status.enum.js.map